import React from 'react';
import PropTypes from 'prop-types';
import './AnonymousContentPanelStyles.scss';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/logo.png';
import autopay from "../../assets/logotypes/autopay.png";
import orange from '../../assets/logotypes/orange.png';
import roovee from '../../assets/logotypes/roovee.png';
import LanguagePicker from './LanguagePicker';
import {useMediaQuery} from "@material-ui/core";
import routePaths from "../../routePaths";

const AnonymousContentPanel = ({ children }) => {
  const [t] = useTranslation();
  const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

  return (
    <div className="anonymous-content-panel">
      <main>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6 col-sm-offset-3">
              <img src={logo} alt="roovee" className="logo img-responsive"/>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-10 col-xs-offset-1 col-sm-4 col-sm-offset-4 col-lg-2 col-lg-offset-5">
              {children}
              <hr/>
              <div className="row">
                <div className="col-xs-6 col-md-5 col-lg-6">
                  <LanguagePicker/>
                </div>
                <div className="col-xs-6 col-md-4 col-md-offset-3 col-lg-6 col-lg-offset-0">
                  <a href={t('signIn.termsAndConditionsUrl')} title={t('signIn.termsAndConditionsLink')} target="_blank"
                     rel="noopener noreferrer"><span>{t('signIn.termsAndConditionsLink')}</span></a>
                  <a href={routePaths.requestPhoneNumberChange}><span>{t('signIn.phoneNumberChangeLink')}</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer>
        <div className="container-fluid">
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: matches ? "row" : "column"
            }}
          >
            <div className="col-sm-3">
              <img src={roovee} alt="roovee"/>
              <p>
                &copy; {new Date().getFullYear()} ROOVEE
                <br/>
                Biuro Obsługi Klienta:
                <br/>
              </p>
              <p>
                tel.: +48 22 300 51 19 <br/>
                <a href="mailto:bok@roovee.eu">bok@roovee.eu</a>
              </p>
            </div>

            <div className="col-sm-3">
              <img src={orange} alt="Orange"/>
            </div>

            <div className="col-sm-3">
              <img src={autopay} alt="Auto pay" style={{height: 120}}/>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
};

AnonymousContentPanel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AnonymousContentPanel;
